module.exports = __webpack_public_path__ + "img/dgqd.a05b905a.png";